<template>
 <div>
   <svg class="checkbox-symbol">
     <symbol id="check" viewbox="0 0 12 10">
       <polyline
         points="1.5 6 4.5 9 10.5 1"
         stroke-linecap="round"
         stroke-linejoin="round"
         stroke-width="2"
       ></polyline>
     </symbol>
   </svg>
   <div class="checkbox-container">
     <input @change="inputChangeHandler" :checked="value" :value="value" class="checkbox-input" id="apples" type="checkbox" />
     <label class="checkbox" for="apples">
    <span>
      <svg width="12px" height="10px">
        <use xlink:href="#check"></use>
      </svg>
    </span>
       <span v-if="label">{{label}}</span>
     </label>
   </div>
 </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  props: {
    label: {
      type: String,
      default: ''
    },
    changeHandler: {
      type: Function
    },
    value: {
      type: Boolean
    }
  },
  methods: {
    inputChangeHandler (e) {
      this.changeHandler(e.target.checked)
    }
  }
})
</script>

<style scoped lang="scss">
.checkbox-symbol {
  position: absolute;
  width: 0;
  height: 0;
  pointer-events: none;
  user-select: none;
}

.checkbox-container {
  box-sizing: border-box;
  background: transparent;
  color: #222;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}

.checkbox-container * {
  box-sizing: border-box;
}

.checkbox-input {
  position: absolute;
  visibility: hidden;
}

.checkbox {
  user-select: none;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
  display: flex;
}

.checkbox:not(:last-child) {
  margin-right: 6px;
}

.checkbox:hover {
  background: rgba(0, 119, 255, 0.06);
}

.checkbox span {
  vertical-align: middle;
  transform: translate3d(0, 0, 0);
}

.checkbox span:first-child {
  position: relative;
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  transform: scale(1);
  border: 1px solid #cccfdb;
  transition: all 0.3s ease;
}

.checkbox span:first-child svg {
  position: absolute;
  top: 3px;
  left: 2px;
  fill: none;
  stroke: #fff;
  stroke-dasharray: 16px;
  stroke-dashoffset: 16px;
  transition: all 0.3s ease;
  transform: translate3d(0, 0, 0);
}

.checkbox span:last-child {
  padding-left: 8px;
  line-height: 18px;
}

.checkbox:hover span:first-child {
  //border-color: #0077ff;
}

.checkbox-input:checked + .checkbox span:first-child {
  background: #6AC5EC;
  border-color: #6AC5EC;
  animation: zoom-in-out 0.3s ease;
}

.checkbox-input:checked + .checkbox span:first-child svg {
  stroke-dashoffset: 0;
}

@keyframes zoom-in-out {
  50% {
    transform: scale(0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/checkbox.vue